/**
 * @generated SignedSource<<fe7a7dd8628383c20a7625a0e3eaf5f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingAuditGiveConsentMutation$variables = {};
export type MeetingAuditGiveConsentMutation$data = {
  readonly giveMeetingAuditConsent: {
    readonly gsuite: {
      readonly delegated: boolean;
      readonly id: string;
    } | null;
    readonly office365: {
      readonly adminConsented: boolean;
      readonly id: string;
    } | null;
  } | null;
};
export type MeetingAuditGiveConsentMutation = {
  response: MeetingAuditGiveConsentMutation$data;
  variables: MeetingAuditGiveConsentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GiveMeetingAuditConsent",
    "kind": "LinkedField",
    "name": "giveMeetingAuditConsent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GSuiteAccountNode",
        "kind": "LinkedField",
        "name": "gsuite",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "delegated",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OfficeAccountNode",
        "kind": "LinkedField",
        "name": "office365",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminConsented",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingAuditGiveConsentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeetingAuditGiveConsentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ca01d71f8371554722c6559aa8eb107c",
    "id": null,
    "metadata": {},
    "name": "MeetingAuditGiveConsentMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingAuditGiveConsentMutation {\n  giveMeetingAuditConsent {\n    gsuite {\n      id\n      delegated\n    }\n    office365 {\n      id\n      adminConsented\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38cf9a8633aa7be9c36b35cff2b5c55a";

export default node;
